type LogPayload = unknown[]

const normalizeEnvFlag = (value: unknown, fallback: boolean) => {
  if (typeof value !== 'string') return fallback
  const normalized = value.trim().toLowerCase()
  if (['1', 'true', 'yes', 'on'].includes(normalized)) return true
  if (['0', 'false', 'no', 'off'].includes(normalized)) return false
  return fallback
}

const isDebugLogEnabled = normalizeEnvFlag(
  import.meta.env.VITE_ENABLE_DEBUG_LOG,
  import.meta.env.DEV,
)

const debug = (...payload: LogPayload) => {
  if (!isDebugLogEnabled) return
  console.log(...payload)
}

const info = (...payload: LogPayload) => {
  if (!isDebugLogEnabled) return
  console.info(...payload)
}

const warn = (...payload: LogPayload) => {
  console.warn(...payload)
}

const error = (...payload: LogPayload) => {
  console.error(...payload)
}

export const logger = {
  debug,
  info,
  warn,
  error,
}
